import type { DataRegion } from "@/types/auth"

function getCurrencyLocaleByRegion(region: DataRegion | undefined) {
  return {
    currency: region === "ca" ? "CAD" : "USD",
    locale: region === "ca" ? "en-CA" : "en-US",
  }
}

export function formatNumber(number: number, options: Intl.NumberFormatOptions = {}) {
  return new Intl.NumberFormat("en-US", {
    ...options,
  }).format(number)
}

export function formatCurrencyByRegion(
  amount: number,
  region: DataRegion | undefined,
  options: Intl.NumberFormatOptions = {},
) {
  const { currency, locale } = getCurrencyLocaleByRegion(region)

  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency,
    maximumFractionDigits: 0,
    ...options,
  }).format(amount)
}

export function formatCurrencyCompactByRegion(
  amount: number,
  region: DataRegion | undefined,
  options: Intl.NumberFormatOptions = {},
) {
  const { currency, locale } = getCurrencyLocaleByRegion(region)

  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency,
    notation: "compact",
    maximumFractionDigits: 1,
    ...options,
  }).format(amount)
}

export function getInitials(firstName?: string | null, lastName?: string | null) {
  const first = firstName?.[0] ?? ""
  const last = lastName?.[0] ?? ""
  return `${first}${last}`.toUpperCase() || "?"
}

export function getFullName(firstName?: string | null, lastName?: string | null) {
  return [firstName, lastName].filter(Boolean).join(" ").trim()
}
